import { StepDto } from '@/api-sdk';
import { isChromeIos, isSafari } from '@/utils';

const DEFAULT_SCROLL_DELAY = 450;

// Go next function with step validation check
export const goToStep = (
  configurator: HTMLElement | undefined,
  currentStep: number,
  delay?: number,
): void => {
  if (!configurator) {
    return;
  }

  const configuratorWidth = configurator.offsetWidth,
    scrollTo = configuratorWidth * currentStep,
    setDelay = delay || DEFAULT_SCROLL_DELAY;

  scrollToStepScreen(configurator, scrollTo, setDelay);
};

export const toggleMobileConfigurator = (
  toggle: boolean,
  wrapper: HTMLElement | undefined,
  isMobile: boolean,
): boolean => {
  if (!wrapper) {
    return false;
  }
  if (isMobile) {
    toggle = !toggle;
  }
  settleConfigurationWrapper(wrapper);
  return toggle;
};

export const settleConfigurationWrapper = (
  element: HTMLElement | undefined,
): void => {
  if (!element) {
    return;
  }

  if (element.classList.contains('settled')) {
    element.classList.remove('settled');
    return;
  }
  setTimeout(() => {
    element.classList.add('settled');
  }, 200);
};

export const setScrollDelay = (stepName: StepDto['type'] | null) => {
  if (stepName?.includes('color')) {
    return DEFAULT_SCROLL_DELAY;
  }
  return 0;
};

/**
 * There is a safari bug in the scrolling behavior https://developer.apple.com/forums/thread/703294
 * When a element has overflow-x: hidden, all scroll events won't work. To fix this we need to set the overflow to auto
 * during the scroll event and set it back to hidden after the scroll event is done. To prevent scrolling during this time
 * we set the pointer-events to none, to prevent the user from scrolling.
 */
export const lockScreenScroll = (
  element: HTMLElement,
  lockTime: number,
): void => {
  element.style.cssText = `
    pointer-events: none;
    overflow-x: auto;
  `;
  setTimeout(() => {
    if (element.attributes.getNamedItem('style')) {
      element.attributes.removeNamedItem('style');
    }
  }, lockTime);
};

const scrollToStepScreen = (
  configurator: HTMLElement,
  scrollTo: number,
  delay: number,
) => {
  if (isSafari() || isChromeIos()) {
    lockScreenScroll(configurator, delay);
  }
  setTimeout(
    /**
     * This timeout is because of a bug when you want to scroll to 0 on a screen that is set to 100vw.
     * see: https://stackoverflow.com/questions/24616322/mobile-safari-why-is-window-scrollto0-0-not-scrolling-to-0-0
     */
    () => {
      configurator.scrollTo({
        left: scrollTo === 0 ? -1 : scrollTo,
        behavior: 'smooth',
      });
    },
    scrollTo === 0 ? 100 : 0,
  );
};
